import React from 'react';
import QuoteScreen from './screens/QuoteScreen';

function Quote() {
  return (
    <>
      <QuoteScreen />
    </>
  );
}

export default Quote;
